import React from 'react'
import { Carousel } from 'react-bootstrap'
import { FaStar } from 'react-icons/fa'

export default function Home() {
    return (
        <>
            <div className="container ">
                <div className="row mx-0">

                    <div className="col-lg-6 pt-5 d-lg-none d-flex ">
                        <div className=" d-flex flex-column align-items-start">
                            <p className=" col-lg-9 col-12 mb-1 text-uppercase">it's time for innovation with</p>
                            <h1 className="h1">a new way of farming</h1>
                            <button className="g-btn mb-4 px-4 mt-1">Buy </button>
                        </div>
                    </div>

                    <div className="col-lg-6 px-0 order-lg-1 order-2  home-left  ">
                        <div className="d-lg-flex d-none flex-column align-items-start">
                            <p className=" col-lg-9 col-12 mb-1 text-uppercase">it's time for innovation with</p>
                            <h1 className="h1">a new way of farming</h1>
                            <button className="g-btn mb-4 px-4 mt-1">Buy </button>
                        </div>

                        <div className="card g-card w-100 mt-lg-5 p-2">
                            <div className="card-body p-4">
                                <h2 className="pt-3">Total value locked ( TVL )</h2>
                                <span className="seprator my-3 mb-4"></span>
                                <div className="row mx-0 w-100">
                                    <div className="col px-0 d-flex align-items-center  ">
                                        <div className="icon-purple me-3">
                                            <img src={process.env.PUBLIC_URL + "/assets/images/x-purple.png"} alt="" />
                                        </div>
                                        <div className="d-flex flex-column">
                                            <small className="text-faded">Circulating Supply</small>
                                            <span className="mb-0 card-sub-heading h ">$10,000,000</span>
                                        </div>
                                    </div>
                                    <div className="col px-0 d-flex align-items-center  ">
                                        <div className="icon-purple pink me-3">
                                            <img src={process.env.PUBLIC_URL + "/assets/images/x-pink.png"} alt="" />
                                        </div>
                                        <div className="d-flex flex-column">
                                            <small className="text-faded">Total Burned</small>
                                            <span className="mb-0 card-sub-heading">$10,000,000</span>
                                        </div>
                                    </div>
                                </div>
                                {/* <span className="seprator my-3 mt-4"></span> */}
                                {/* <small className="text-faded text-uppercase ps-0">STATICTICS</small> */}
                                <span className="seprator colored my-3 "></span>
                                {/* <div className="d-flex justify-content-between w-100">
                                    <div className=" px-0 d-flex align-items-center  ">
                                        <div className="d-flex flex-column">
                                            <span className="mb-0 card-sub-heading">$32,321,566</span>
                                            <small className="text-faded">Lorem Ipsum</small>
                                        </div>
                                    </div>
                                    <div className=" px-0 d-flex align-items-center pe-lg-5 me-lg-2 pe-0  ">
                                        <div className="d-flex flex-column">
                                            <span className="mb-0 card-sub-heading">$32,321,566</span>
                                            <small className="text-faded">Lorem Ipsum</small>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 home-img d-flex order-lg-2 order-1 ">
                        <img src={process.env.PUBLIC_URL + '/assets/images/cartoon.png'} alt="" />
                    </div>
                </div>

                <div className="row mx-0 mt-4 align-items-start">
                    <div className="col-lg-4 pe-lg-2 py-0 pe-0 ps-0">
                        <div className="card p-lg-2">
                            <div className="card-body">
                                <small className="text-faded text-uppercase"> user status</small>
                                <div className="d-flex justify-content-between row-active align-items-center mt-1 py-2 ">
                                    <div className="">
                                        <FaStar className="me-1" /> <span>Harvest</span>
                                    </div>
                                    <div className=" text-end"><span className="text-purple ">$228,112,660</span></div>
                                </div>
                                <div className="d-flex justify-content-between row-faded align-items-center  py-2 ">
                                    <div className="">
                                        <FaStar className="me-1" /> <span className="faded-span">Locked </span>
                                    </div>
                                    <div className=" text-end"><span className="text-pink ">$228,112,660</span></div>
                                </div>
                                <div className="d-flex flex-column">
                                    <span className="pt-1">REWARDS</span>
                                    <div className="d-flex justify-content-between align-items-center pt-2">
                                        <div className="ws-x-box">
                                            <img src={process.env.PUBLIC_URL + "assets/images/x-orange.png"} alt="" />
                                        </div>
                                        <img src={process.env.PUBLIC_URL + "assets/images/check.png"} className="check-icon" alt="" />
                                        <div className="ws-x-box">
                                            <img src={process.env.PUBLIC_URL + "assets/images/x-gray.png"} alt="" />
                                        </div>
                                        <img src={process.env.PUBLIC_URL + "assets/images/cross.png"} className="check-icon" alt="" />
                                        <div className="ws-x-box">
                                            <img src={process.env.PUBLIC_URL + "assets/images/x-golden.png"} alt="" />
                                        </div>
                                        <img src={process.env.PUBLIC_URL + "assets/images/cross.png"} className="check-icon" alt="" />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 px-lg-2 py-lg-0 py-3 px-0 ">
                        <div className="card p-lg-2">
                            <div className="card-body">
                                <small className="text-faded text-uppercase"> reaper status</small>
                                <div className="d-flex justify-content-between row-active align-items-center mt-1 py-2 ">
                                    <div className="">
                                        <FaStar className="me-1" /> <span>Market Cap</span>
                                    </div>
                                    <div className=" text-end"><span className="text-purple ">$228,112,660</span></div>
                                </div>
                                <div className="d-flex justify-content-between row-faded align-items-center  py-2 ">
                                    <div className="">
                                        <FaStar className="me-1" /> <span className="faded-span">Total Supply</span>
                                    </div>
                                    <div className=" text-end"><span className="text-pink ">$228,112,660</span></div>
                                </div>
                                <div className="d-flex justify-content-between row-faded align-items-center  py-2 ">
                                    <div className="">
                                        <FaStar className="me-1" /> <span className="faded-span">Burned To Date</span>
                                    </div>
                                    <div className=" text-end"><span className="text-purple">$4.5 billion</span></div>
                                </div>
                                <div className="d-flex justify-content-between row-faded align-items-center  py-2 ">
                                    <div className="">
                                        <FaStar className="me-1" /> <span className="faded-span">Block Emissions</span>
                                    </div>
                                    <div className=" text-end"><span className="text-pink ">15/block</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 ps-lg-2 ps-0 py-0 pe-0">
                        <div className="card p-lg-2">
                            <div className="card-body">
                                <small className="text-faded text-uppercase"> treasury status</small>
                                <div className="d-flex justify-content-between row-active align-items-center mt-1 py-2 ">
                                    <div className="">
                                        <FaStar className="me-1" /> <span>Total Locked</span>
                                    </div>
                                    <div className=" text-end"><span className="text-purple ">$228,112,660</span></div>
                                </div>
                                <div className="d-flex justify-content-between row-faded align-items-center  py-2 ">
                                    <div className="">
                                        <FaStar className="me-1" /> <span className="faded-span">Interest In 7 Days</span>
                                    </div>
                                    <div className=" text-end"><span className="text-pink ">$228,112,660</span></div>
                                </div>
                                <div className="d-flex justify-content-between row-faded align-items-center  py-2 ">
                                    <div className="">
                                        <FaStar className="me-1" /> <span className="faded-span">Interest In 30 Days</span>
                                    </div>
                                    <div className=" text-end"><span className="text-purple">$4.5 billion</span></div>
                                </div>
                                <div className="d-flex justify-content-between row-faded align-items-center  py-2 ">
                                    <div className="">
                                        <FaStar className="me-1" /> <span className="faded-span">Total Interest</span>
                                    </div>
                                    <div className=" text-end"><span className="text-pink ">$100000</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <h2 className="h2 px-2 py-4 mt-2">Latest Announcements</h2>
                <div className="row mx-0">
                    <div className="col-lg-6 ps-0 pe-lg-2 pe-0 py-2">
                        <div className="card">
                            <div className="card-body">
                                <div className="row mx-0 w-100">
                                    <div className="card-imgs col-lg-4 px-0">
                                        <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/news-1.png"} alt="" />
                                    </div>
                                    <div className="col-lg-8 d-flex justify-content-center flex-column pt-lg-0 pt-3">
                                        <p>Lorem ipsum dolor sit, amet consecr adipisicing elit. Inventore, sequi.</p>
                                        <small className="text-faded-white">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci error cum ad, porro obcaecati sunt.</small>
                                        <div className=""> <span className="text-pink">Lorem Ipsum</span><span className="text-faded-white ps-2"> . 47min ago</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 pe-0 ps-lg-2 ps-0 py-2">
                        <div className="card">
                            <div className="card-body">
                                <div className="row mx-0 w-100">
                                    <div className="card-imgs col-lg-4 px-0">
                                        <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/news-1.png"} alt="" />
                                    </div>
                                    <div className="col-lg-8 d-flex justify-content-center flex-column pt-lg-0 pt-3">
                                        <p>Lorem ipsum dolor sit, amet consecr adipisicing elit. Inventore, sequi.</p>
                                        <small className="text-faded-white">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci error cum ad, porro obcaecati sunt.</small>
                                        <div className=""> <span className="text-pink">Lorem Ipsum</span><span className="text-faded-white ps-2"> . 47min ago</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h2 className="h2 px-2 py-4 mt-2">Latest News</h2>

                    <div className="col-lg-6 ps-0 pe-lg-2 pe-0 py-2 news">
                        <div className="card">
                            <div className="card-body ">
                                <Carousel>
                                    <Carousel.Item>
                                        <div className="row mx-0 w-100 pb-2 ">
                                            <div className="card-imgs col-lg-4 px-0">
                                                <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/news-1.png"} alt="" />
                                            </div>
                                            <div className="col-lg-8 d-flex justify-content-center flex-column pt-lg-0 pt-3">
                                                <p>Lorem ipsum dolor sit, amet consecr adipisicing elit. Inventore, sequi.</p>
                                                <small className="text-faded-white">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci error cum ad, porro obcaecati sunt.</small>
                                                <div className=""> <span className="text-pink">Lorem Ipsum</span><span className="text-faded-white ps-2"> . 47min ago</span></div>
                                            </div>
                                        </div>
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <div className="row mx-0 w-100 pb-2 ">
                                            <div className="card-imgs col-lg-4 px-0">
                                                <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/news-1.png"} alt="" />
                                            </div>
                                            <div className="col-lg-8 d-flex justify-content-center flex-column pt-lg-0 pt-3">
                                                <p>Lorem ipsum dolor sit, amet consecr adipisicing elit. Inventore, sequi.</p>
                                                <small className="text-faded-white">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci error cum ad, porro obcaecati sunt.</small>
                                                <div className=""> <span className="text-pink">Lorem Ipsum</span><span className="text-faded-white ps-2"> . 47min ago</span></div>
                                            </div>
                                        </div>
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <div className="row mx-0 w-100 pb-2 ">
                                            <div className="card-imgs col-lg-4 px-0">
                                                <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/news-1.png"} alt="" />
                                            </div>
                                            <div className="col-lg-8 d-flex justify-content-center flex-column pt-lg-0 pt-3">
                                                <p>Lorem ipsum dolor sit, amet consecr adipisicing elit. Inventore, sequi.</p>
                                                <small className="text-faded-white">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci error cum ad, porro obcaecati sunt.</small>
                                                <div className=""> <span className="text-pink">Lorem Ipsum</span><span className="text-faded-white ps-2"> . 47min ago</span></div>
                                            </div>
                                        </div>
                                    </Carousel.Item>
                                </Carousel>


                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 pe-0 ps-lg-2 ps-0 py-2 news">
                        <div className="card">
                            <div className="card-body ">
                                <Carousel>
                                    <Carousel.Item>
                                        <div className="row mx-0 w-100 pb-2 ">
                                            <div className="card-imgs col-lg-4 px-0">
                                                <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/news-1.png"} alt="" />
                                            </div>
                                            <div className="col-lg-8 d-flex justify-content-center flex-column pt-lg-0 pt-3">
                                                <p>Lorem ipsum dolor sit, amet consecr adipisicing elit. Inventore, sequi.</p>
                                                <small className="text-faded-white">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci error cum ad, porro obcaecati sunt.</small>
                                                <div className=""> <span className="text-pink">Lorem Ipsum</span><span className="text-faded-white ps-2"> . 47min ago</span></div>
                                            </div>
                                        </div>
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <div className="row mx-0 w-100 pb-2 ">
                                            <div className="card-imgs col-lg-4 px-0">
                                                <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/news-1.png"} alt="" />
                                            </div>
                                            <div className="col-lg-8 d-flex justify-content-center flex-column pt-lg-0 pt-3">
                                                <p>Lorem ipsum dolor sit, amet consecr adipisicing elit. Inventore, sequi.</p>
                                                <small className="text-faded-white">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci error cum ad, porro obcaecati sunt.</small>
                                                <div className=""> <span className="text-pink">Lorem Ipsum</span><span className="text-faded-white ps-2"> . 47min ago</span></div>
                                            </div>
                                        </div>
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <div className="row mx-0 w-100 pb-2 ">
                                            <div className="card-imgs col-lg-4 px-0">
                                                <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/news-1.png"} alt="" />
                                            </div>
                                            <div className="col-lg-8 d-flex justify-content-center flex-column pt-lg-0 pt-3">
                                                <p>Lorem ipsum dolor sit, amet consecr adipisicing elit. Inventore, sequi.</p>
                                                <small className="text-faded-white">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci error cum ad, porro obcaecati sunt.</small>
                                                <div className=""> <span className="text-pink">Lorem Ipsum</span><span className="text-faded-white ps-2"> . 47min ago</span></div>
                                            </div>
                                        </div>
                                    </Carousel.Item>
                                </Carousel>


                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="d-flex justify-content-center mt-4">
                    <button className="btn-outline"><span>More News</span></button>
                </div> */}
            </div>
        </>
    )
}
